import { useAuth } from '@/auth';
import { checkAnyPermissions, PERMISSIONS } from '@/auth/permissions';

/**
 * Permisos del módulo de presupuestos independientes.
 *
 * Ocultar botones acá es solo comodidad: el backend valida cada acción.
 */
export const usePresupuestosProformaPermissions = () => {
  const { user } = useAuth();
  const userPermissions = user?.permissions || [];

  const can = (permission: string) =>
    checkAnyPermissions(userPermissions, [permission, PERMISSIONS.FULL_ACCESS.name]);

  const canView = can(PERMISSIONS.VIEW_PRESUPUESTOS_PROFORMA.name);
  const canCreate = can(PERMISSIONS.CREATE_PRESUPUESTOS_PROFORMA.name);
  const canEdit = can(PERMISSIONS.EDIT_PRESUPUESTOS_PROFORMA.name);
  const canDelete = can(PERMISSIONS.DELETE_PRESUPUESTOS_PROFORMA.name);
  const canConfirm = can(PERMISSIONS.CONFIRM_PRESUPUESTOS_PROFORMA.name);
  const canArchive = can(PERMISSIONS.ARCHIVE_PRESUPUESTOS_PROFORMA.name);
  const canExport = can(PERMISSIONS.EXPORT_PRESUPUESTOS_PROFORMA.name);
  const canImport = can(PERMISSIONS.IMPORT_PRESUPUESTOS_PROFORMA.name);
  const canManageBases = can(PERMISSIONS.MANAGE_PRESUPUESTOS_BASE.name);

  return {
    canView,
    canCreate,
    canEdit,
    canDelete,
    canConfirm,
    canArchive,
    canExport,
    canImport,
    canManageBases,
    hasAnyPermission: canView || canCreate || canEdit || canDelete,
  };
};
